import styled, { css } from 'styled-components';
import type { SnackbarType, SnackbarOrigin } from '@makemydeal/dr-ui-bricks-types';

//TODO: All the colors would be replaced by ui-bricks theme variables

export const backgroundColorByType = (_theme: any): Record<SnackbarType, string> => ({
    info: '#ECF3FA',
    error: '#FDF5F6'
});

export const borderColorByType = (theme?: any): Record<SnackbarType, string> => ({
    info: theme?.uiBricks?.cardButtonColor || '#0D65BF',
    error: theme?.uiBricks?.errorInputFieldBorderColor || '#9a010e'
});

export const StyledSnackbar = styled.div<{ anchor: SnackbarOrigin; isVisible: boolean; type: SnackbarType }>`
    ${({ theme, type }) => css`
        position: fixed;
        z-index: 1400;
        min-width: 288px;
        max-width: 568px;
        padding: 12px 16px;
        background-color: ${backgroundColorByType(theme)[type]};
        border: 2px solid ${borderColorByType(theme)[type]};
        display: flex;
        align-items: center;
        transition: opacity 0.3s ease;
        gap: 12px;
    `}

    ${({ anchor }) => css`
        ${anchor.vertical}: 56px;
        ${anchor.horizontal === 'center'
            ? 'left: 40%; transform: translateX(-50%);'
            : anchor.horizontal === 'left'
            ? 'left: 24px;'
            : 'right: 24px;'}
    `}
`;

export const Content = styled.span`
    ${({ theme }) => css`
        flex: 1;
        font-size: ${theme.uiBricks.baseFontSizeTablet};
        color: ${theme.uiBricks.activeInputFieldBorderColor};
    `}
`;

export const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

export const SnackbarCloseButton = styled.button`
    ${({ theme }) => css`
        background: none;
        border: none;
        font-size: 24px;
        font-weight: 600;
        cursor: pointer;
        padding: 0;
        flex-shrink: 0;
        color: ${theme.uiBricks.commonPaymentDisclaimerTextColor};
    `}
`;
